/* this file is transformed by vux-loader */
/* eslint-disable */
var userAgent = window.navigator.userAgent;

var inWeiXin = function inWeiXin() {
  return /MicroMessenger\/([\d.]+)/i.test(userAgent);
};

export { inWeiXin };